import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const NoticeBar = styled.div`
  ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
  gap: 0 6px;
  padding: 10px 16px;
  margin: 0 auto;
  background: #f6f6f6;

  &.color-type-black {
    background: #252525;
    color: #ddd;

    &.clock g {
      stroke: #ddd;
    }

    &.notice g path {
      fill: #ddd;
    }
  }

  &.color-type-opacity {
    background: rgba(172, 172, 172, 0.15);
  }

  svg {
    margin-top: 2px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    gap: ${mixin.pxToVw('0 6')};
    padding: ${mixin.pxToVw('10 16')};

    svg {
      width: ${mixin.pxToVw('14')};
      height: ${mixin.pxToVw('14')};
      margin-top: ${mixin.pxToVw('2')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    gap: 0 10px;
    padding: 13.5px 40px;

    svg {
      width: 20px;
      height: 20px;
      margin-top: 1.5px;
    }

    .text {
      font-size: 18px;

      br {
        display: none;
      }
    }
  }
`;
